// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"a720307f","29":"ba48ac8d","324":"584e8ef8","617":"534a05e7","708":"4273a0c1","935":"fc521867"}[chunkId] + ".chunk.js";
};